export default ({ request }) => ({
  purchasePackageListApi(data = {}) {
    return request({
      url: "/factory/purchase/package/list",
      method: "post",
      data,
    })
  },
  purchasePackageAddApi(data = {}) {
    return request({
      url: "/factory/purchase/package/add",
      method: "post",
      data,
    })
  },
  purchasePackageDelApi(data = {}) {
    return request({
      url: "/factory/purchase/package/del",
      method: "post",
      data,
    })
  },
  purchasePackageAuditApi(data = {}) {
    return request({
      url: "/factory/purchase/package/audit",
      method: "post",
      data,
    })
  },
  purchasePackageModifyApi(data = {}) {
    return request({
      url: "/factory/purchase/package/modify",
      method: "post",
      data,
    })
  },
  purchasePackageDetailApi(data = {}) {
    return request({
      url: "/factory/purchase/package/detail",
      method: "post",
      data,
    })
  },
  purchasePackageDetailListApi(data = {}) {
    return request({
      url: "/factory/purchase/package/detail/list",
      method: "post",
      data,
    })
  },
  purchasePackageDetailAddApi(data = {}) {
    return request({
      url: "/factory/purchase/package/detail/add",
      method: "post",
      data,
    })
  },
  purchasePackageDetailModifyApi(data = {}) {
    return request({
      url: "/factory/purchase/package/detail/modify",
      method: "post",
      data,
    })
  },
  purchasePackageDetDeatilApi(data = {}) {
    return request({
      url: "/factory/purchase/package/detail/detail",
      method: "post",
      data,
    })
  },
  purchasePackageDeatilBatchDelApi(data = {}) {
    return request({
      url: "/factory/purchase/package/detail/batchDel",
      method: "post",
      data,
    })
  },

  purchasePackageBatchListApi(data = {}) {
    return request({
      url: "/factory/purchase/package/batch/list",
      method: "post",
      data,
    })
  },

  purchasePackageBatchDetailApi(data = {}) {
    return request({
      url: "/factory/purchase/package/batch/detail",
      method: "post",
      data,
    })
  },

  purchasePackageBatchAddApi(data = {}) {
    return request({
      url: "/factory/purchase/package/batch/add",
      method: "post",
      data,
    })
  },

  purchasePackageBatchModifyApi(data = {}) {
    return request({
      url: "/factory/purchase/package/batch/modify",
      method: "post",
      data,
    })
  },

  purchasePackageBatchDelApi(data = {}) {
    return request({
      url: "/factory/purchase/package/batch/del",
      method: "post",
      data,
    })
  },

  purchasePackageExpenseListApi(data = {}) {
    return request({
      url: "/factory/purchase/package/expense/list",
      method: "post",
      data,
    })
  },

  purchasePackageExpenseDetailApi(data = {}) {
    return request({
      url: "/factory/purchase/package/expense/detail",
      method: "post",
      data,
    })
  },

  purchasePackageExpenseAddApi(data = {}) {
    return request({
      url: "/factory/purchase/package/expense/add",
      method: "post",
      data,
    })
  },

  purchasePackageExpenseModifyApi(data = {}) {
    return request({
      url: "/factory/purchase/package/expense/modify",
      method: "post",
      data,
    })
  },

  purchasePackageExpenseDelApi(data = {}) {
    return request({
      url: "/factory/purchase/package/expense/del",
      method: "post",
      data,
    })
  },
})
